export function testReducedMotion() {
  if (typeof window !== 'undefined') {
    return !!window.matchMedia && window.matchMedia('(prefers-reduced-motion)').matches
  }
  return false
}
